export const GET_COACHMARKS = 'GET_COACHMARKS';
export const UPDATE_COACHMARK = 'UPDATE_COACHMARK';
